.connectorCell {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-x-small);
}

.connectorName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.secondaryText {
    font-size: var(--exo-font-size-x-small);
    color: var(--exo-color-font-secondary);
}
